import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {LanguageService} from '../../../common/languages/language.service';
import {RoleService} from '../../role/role.service';
import {NgForm} from "@angular/forms";
import {StateService} from "../../../core/services/state.service";
import {UserModel} from "common-shared";

@Component({
  selector: 'mes-user-edit',
  templateUrl: './user-edit.component.html',
})
export class UserEditComponent implements OnInit {
  @Input() user: UserModel;
  @Output() userChanged = new EventEmitter<boolean>();
  @ViewChild(NgForm, {static: true}) form: NgForm;

  constructor(public languageService: LanguageService, public rolesService: RoleService, public stateService: StateService) {
  }

  ngOnInit() {
    this.form.statusChanges.subscribe(() => {
      if (!this.form.pristine) {
        this.userChanged.emit(this.form.pristine);
      }
    });
  }
}
